export interface IEffectiveActualsSync {
  fYear: number
  currentFQuarter: number
  fQuarterActualsPercentage: number
  isCurrentFYear: boolean
}

interface IParams {
  selectedFYear: number
  realFYear: number
  realCurrentFQuarter: number
  realFQuarterActualsPercentage: number
}

/** Scopes the real "today, mapped onto a fiscal quarter" values to the fiscal year the cockpit is
 *  actually viewing. A past year is treated as fully closed (`currentFQuarter` past Q4, so every
 *  quarter reads as actuals); a future year as fully unstarted (`currentFQuarter` before Q1, so
 *  every quarter reads as plan and nothing has "happened yet" for YTD purposes). */
export const getEffectiveActualsSync = ({
  selectedFYear,
  realFYear,
  realCurrentFQuarter,
  realFQuarterActualsPercentage,
}: IParams): IEffectiveActualsSync => {
  if (selectedFYear === realFYear) {
    return {
      fYear: selectedFYear,
      currentFQuarter: realCurrentFQuarter,
      fQuarterActualsPercentage: realFQuarterActualsPercentage,
      isCurrentFYear: true,
    }
  }

  if (selectedFYear < realFYear) {
    return {
      fYear: selectedFYear,
      currentFQuarter: 5,
      fQuarterActualsPercentage: 1,
      isCurrentFYear: false,
    }
  }

  return {
    fYear: selectedFYear,
    currentFQuarter: 0,
    fQuarterActualsPercentage: 0,
    isCurrentFYear: false,
  }
}
